import axios from '@/api/axios'

const getCompetitions = () => {
  return axios.get(`/competition`)
}

const getCompetitionList = (params) => {
  return axios.get(`/competitionsListForAdmin/`, {params})
}

const getCompetitionCalendarPlan = (params) => {
  return axios.get(`/competitionCalendarPlans${params}`)
}

const competitionCalendarPlan = (id) => {
  return axios.get(`/competitionCalendarPlans/${id}`)
}

const updateCompetitionCalendarPlan = (id, data) => {
  return axios.put(`/competitionCalendarPlans${id}`, data)
}

const competitionCalendarPlansFilterResult = (id) => {
  return axios.get(`/competitionCalendarPlans/${id}/filterResult`)
}

const deleteCompetitionCalendarPlan = (id) => {
  return axios.delete(`/competitionCalendarPlans/${id}`)
}

const addCompetitionCalendarPlans = (plan) => {
  return axios.post(`/competitionCalendarPlans`, plan)
}

const getCompetitionsForCalendar = (params) => {
  return axios.get(`/competitionsForCalendar`, {params})
}

const getCompetition = (id) => {
  return axios.get(`/competition/${id}`)
}

const addCompetition = (competition) => {
  return axios.post(`/competition`, competition)
}

const updateCompetition = (competition) => {
  return axios.put(`/competition/${competition.id}`, competition)
}

const getCompetitionsSchoolId = (schoolId, schoolType) => {
  return axios.get(`/competition?schoolId=${schoolId}&schoolType=${schoolType}`)
}

const deleteCompetition = (id) => {
  return axios.delete(`/competition/${id}`)
}

const getCompetitionTrainersList = (params) => {
  return axios.get(`/competition/${params.id}/trainers`, {params})
}

const deleteCompetitionTrainers = (id) => {
  return axios.delete(`/competition/${id}`)
}

const addCompetitionTrainers = (trainer, id) => {
  return axios.patch(`/competition/${id}/trainers`, trainer)
}

const getCompetitionAthletesList = (params) => {
  return axios.get(`/competition/${params.id}/athletes`, {params})
}

const deleteCompetitionAthletes = (id) => {
  return axios.delete(`/competition/${id}`)
}

const addCompetitionAthletes = (trainer, id) => {
  return axios.patch(`/competition/${id}/athletes`, trainer)
}

export default {
  getCompetitions,
  getCompetitionsSchoolId,
  getCompetition,
  addCompetition,
  updateCompetition,
  deleteCompetition,
  getCompetitionList,
  getCompetitionCalendarPlan,
  competitionCalendarPlansFilterResult,
  getCompetitionsForCalendar,
  addCompetitionCalendarPlans,
  competitionCalendarPlan,
  updateCompetitionCalendarPlan,
  deleteCompetitionCalendarPlan,
  getCompetitionTrainersList,
  deleteCompetitionTrainers,
  addCompetitionTrainers,

  getCompetitionAthletesList,
  deleteCompetitionAthletes,
  addCompetitionAthletes,
}
